import { useQuery } from '@tanstack/react-query';
import { getAssociatedInvoices } from '../Services/ProcessedTimesheetService';

const useGetAssociatedInvoices = (params, options) =>
    useQuery({
        queryKey: ['getAssociatedInvoices', params],
        queryFn: () => getAssociatedInvoices(params),
        ...options,
    });

export default useGetAssociatedInvoices;
